import React, { Component } from "react";
import PropTypes from "prop-types";

import AllCountries from "./data";
import Utils from "./utils";
import { getCookie } from "../../utils";

class CountrySelector extends Component {
  constructor(props) {
    super(props);
    this.countryUl = React.createRef();
    this.dropDownDiv = React.createRef();
    this.searchInputElement = React.createRef();
    this.state = {
      countryListOpened: false,
      value: Utils.formatNumber(
        this.props.value,
        this.props.selectedCountryCode || "in"
      ),
      selectedCountry: AllCountries.getCountry(
        this.props.selectedCountryCode || "in"
      ),
    };
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);

    const cookieData = getCookie("bp_customer");

    if (!cookieData || cookieData === "") return;

    if (cookieData.mobile && cookieData.countryCode) {
      const userCountryCode = AllCountries.getCountryFromCode(
        cookieData.iso3code
      );

      this.setState({
        selectedCountry: userCountryCode,
        value: Utils.formatNumber(cookieData.mobile, userCountryCode),
      });
    }
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }
  componentDidUpdate(prevProps, prevState) {
    if (!prevState.countryListOpened && this.state.countryListOpened) {
      this.searchInputElement.current.value = "";
      this.searchInputElement.current.focus();
      this.setDropdownPosition();
    }
  }

  setDropdownPosition = () => {
    const scrollHeight = document
      .getElementsByClassName("country")[0]
      .children[0].children[1].querySelector("ul > li.selected").offsetTop;
    document.getElementsByClassName(
      "country"
    )[0].children[0].children[1].scrollTop = scrollHeight - 78;
  };

  handleOnBlur() {
    const { dropDownDiv } = this;
    const isValid = Utils.isValidNumber(
      this.state.value,
      this.state.selectedCountry.iso2
    );
    const formattedNumber = Utils.formatNumber(
      this.state.value,
      this.state.selectedCountry.iso2
    );

    if (
      dropDownDiv &&
      dropDownDiv.current &&
      dropDownDiv.current.classList.contains("open")
    ) {
      dropDownDiv.current.classList.remove("open");
      this.setState({ searchTerm: "", countryListOpened: false });
    }
    this.setState({ value: isValid ? formattedNumber : this.state.value });
    if (this.props.onPhoneNumberBlur) {
      this.props.onPhoneNumberBlur(
        this.state.value,
        this.state.selectedCountry,
        isValid
      );
    }
  }

  handleOnChange(e) {
    const countryFromNumber = Utils.getCountryCodeFromNumber(e.target.value);
    let { selectedCountry } = this.state;
    if (countryFromNumber) {
      selectedCountry = countryFromNumber;
      this.setState({ selectedCountry, countryListOpened: false });
    }
    const formattedNumber = Utils.formatNumber(
      Utils.getNumber(e),
      selectedCountry.iso2
    );
    const nonFormattedNumber = Utils.getNonFormattedNumber(
      formattedNumber,
      selectedCountry
    );
    const isValid = Utils.isValidNumber(
      Utils.getNumber(e),
      selectedCountry.iso2
    );

    this.setState({ value: formattedNumber });

    if (this.props.onPhoneNumberUpdate) {
      this.props.onPhoneNumberUpdate(
        nonFormattedNumber,
        formattedNumber,
        selectedCountry,
        isValid,
        e
      );
    }
  }

  onBlur = (e) => {
    e.currentTarget.parentElement.classList.remove("active");
    this.handleOnBlur();
  };

  onFocus = (e) => {
    e.currentTarget.parentElement.classList.add("active");
    const inputValue = document.getElementById("phoneNo-req").value;
    const nonFormattedNumberForInputValue = Utils.getNonFormattedNumber(
      inputValue,
      this.state.selectedCountry
    );
    const nonFormattedNumber = Utils.getNonFormattedNumber(
      this.state.value,
      this.state.selectedCountry
    );
    if (nonFormattedNumberForInputValue !== nonFormattedNumber) {
      this.setState({ value: nonFormattedNumberForInputValue });
    } else {
      this.setState({ value: nonFormattedNumber });
    }
  };

  handleDropDownClick = (event) => {
    event.stopPropagation();

    const dropDownDiv = this.dropDownDiv.current;
    if (!dropDownDiv.classList.contains("open")) {
      dropDownDiv.classList.add("open");
      this.setState({ searchTerm: "", countryListOpened: true });
    } else if (event.target.parentElement.className !== "intl-searchbox") {
      dropDownDiv.classList.remove("open");
      this.setState({ ...this.state, countryListOpened: false });
    }
  };

  handleCountrySelectionClick = (event) => {
    event.stopPropagation();

    event.currentTarget.children[0].classList.add("g-radio-selected");
    const selectedCountryCode =
      event.currentTarget.getAttribute("data-country-code");
    const dropDownDiv = this.dropDownDiv.current;
    dropDownDiv.classList.remove("open");

    const number = Utils.getNonFormattedNumber(
      this.state.value,
      this.state.selectedCountry
    );

    const selectedCountry = AllCountries.getCountry(selectedCountryCode);

    const formattedNumber = Utils.formatNumber(number, selectedCountry.iso2);
    const nonFormattedNumber = Utils.getNonFormattedNumber(
      formattedNumber,
      selectedCountry
    );

    this.setState({
      countryListOpened: false,
      value: formattedNumber,
      selectedCountry,
    });
    if (this.state.selectedCountry.iso3 !== selectedCountryCode) {
      this.props.countryCodeUpdated(
        selectedCountry,
        formattedNumber,
        nonFormattedNumber,
        Utils.isValidNumber(nonFormattedNumber, selectedCountry.iso2)
      );
    }
  };

  handleSearchKeyUp = (event) => {
    event.stopPropagation();
    const value = event.currentTarget.value.toLowerCase().trim();
    if (value !== this.state.searchTerm) {
      this.setState({ ...this.state, searchTerm: value });
    }
  };

  handleClickOutside = (event) => {
    if (this.dropDownDiv && !this.dropDownDiv.current.contains(event.target)) {
      const dropDownDiv = this.dropDownDiv.current;
      dropDownDiv.classList.remove("open");
      this.handleOnBlur();
    }
  };

  renderCountryList() {
    if (!this.state.countryListOpened) {
      return null;
    }
    const countryCodeArray = AllCountries.getCountries();
    const template = [];

    if (this.state.searchTerm) {
      for (let i = 0; i < countryCodeArray.length; i += 1) {
        const country = countryCodeArray[i];
        if (
          country.name.toLowerCase().indexOf(this.state.searchTerm) !== -1 ||
          `+${country.dialCode}`
            .toLowerCase()
            .indexOf(this.state.searchTerm) !== -1
        ) {
          template.push(
            this.countryList(
              country,
              this.state.selectedCountry.iso2 === country.iso2
            )
          );
        }
      }
    } else {
      for (let i = 0; i < countryCodeArray.length; i += 1) {
        const country = countryCodeArray[i];
        template.push(
          this.countryList(
            country,
            this.state.selectedCountry.iso2 === country.iso2
          )
        );
      }
    }
    if (template.length > 0) {
      return template;
    }
    return null;
  }

  renderSelectedCountry() {
    const country = this.state.selectedCountry;

    return (
      <div className="intl-country-set">
        <i className={`flag-ele ${country.iso2}`}></i>
        <code>+{country.dialCode}</code>
        <span className="intl-select-arrow"></span>
      </div>
    );
  }

  countryList(country, selected) {
    return (
      <li
        key={country.iso2}
        data-dial-code={country.dialCode}
        data-country-code={country.iso2}
        data-testid={country.iso2}
        data-country-code-iso3={country.iso3}
        onClick={this.handleCountrySelectionClick}
        className={selected ? "selected" : ""}
      >
        <button className="intl-radio"></button>
        <i className={`flag-ele ${country.iso2.toLowerCase()}`}></i>
        <span className="intl-country-name">
          {country.name} +{country.dialCode}
        </span>
      </li>
    );
  }

  render() {
    return (
      <div className={this.props.className}>
        <div
          className="intl-dropdown country"
          ref={this.dropDownDiv}
          data-testid={"dropDown"}
          onClick={this.handleDropDownClick}
        >
          <div tabIndex="0">
            <div className="intl-select">{this.renderSelectedCountry()}</div>
            <div className="intl-menu">
              <div className="intl-searchbox">
                <svg
                  viewBox="-4 -4 23 23"
                  id="g-search"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M14.744 13.657a.31.31 0 01.086.229.419.419 0 01-.086.257l-.658.63a.356.356 0 01-.258.115.272.272 0 01-.23-.115l-3.492-3.464a.38.38 0 01-.086-.23v-.4a6.151 6.151 0 01-1.804 1.074 5.759 5.759 0 01-2.09.386 5.784 5.784 0 01-2.993-.802A6.017 6.017 0 01.972 9.176 5.784 5.784 0 01.17 6.183a5.78 5.78 0 01.802-2.992A6.017 6.017 0 013.133 1.03 5.784 5.784 0 016.126.228c1.088 0 2.085.267 2.992.801a6.017 6.017 0 012.162 2.162c.534.907.801 1.904.801 2.992 0 .726-.129 1.422-.386 2.09a6.151 6.151 0 01-1.074 1.804h.4a.31.31 0 01.23.086l3.493 3.494zm-8.618-2.892c.82 0 1.584-.206 2.29-.616a4.549 4.549 0 001.675-1.675c.41-.706.616-1.47.616-2.29 0-.822-.205-1.585-.616-2.291a4.549 4.549 0 00-1.675-1.675 4.481 4.481 0 00-2.29-.616c-.821 0-1.585.205-2.291.616A4.549 4.549 0 002.16 3.893a4.481 4.481 0 00-.616 2.29c0 .821.205 1.585.616 2.291.41.706.969 1.265 1.675 1.675.706.41 1.47.616 2.29.616z"></path>
                </svg>
                <input
                  placeholder="Search in dropdown"
                  ref={this.searchInputElement}
                  onKeyUp={this.handleSearchKeyUp}
                  data-testid={"searchCountry"}
                />
              </div>
              <ul ref={this.countryUl}>{this.renderCountryList()}</ul>
            </div>
          </div>
        </div>
        <div className={`intl-field-group ${this.props.classList}`}>
          <input
            className="intl-phone-input"
            placeholder="Phone"
            type="tel"
            value={this.state.value}
            name="phone"
            id="phoneNo-req"
            data-testid={"phoneNo-req"}
            onChange={(e) => {
              this.handleOnChange(e);
            }}
            onFocus={(e) => {
              this.onFocus(e);
            }}
            onBlur={(e) => {
              this.onBlur(e);
            }}
            onKeyPress={(e) => {
              e.key === "Enter" && e.preventDefault();
            }}
          />
        </div>
      </div>
    );
  }
}

CountrySelector.propTypes = {
  selectedCountryCode: PropTypes.string,
  countryCodeUpdated: PropTypes.func,
  onPhoneNumberUpdate: PropTypes.func,
  onPhoneNumberBlur: PropTypes.func,
  value: PropTypes.string,
  format: PropTypes.string,
  classList: PropTypes.string,
  className: PropTypes.string,
  field: PropTypes.object,
  isPhoneNumberEmptyWhenRequired: PropTypes.bool,
};

export default CountrySelector;
